import { signOut } from "firebase/auth";
import { useAuthContext } from "../../components/AuthContext";
import HeadBlock from "../../components/HeadBlock";
import Header from "../../components/Header";
import Nav from "../../components/Nav";
import { auth, functions } from "../../firebase";
import styles from "../../assets/styles/menu.module.scss";
import iconStyles from "../../assets/styles/icon.module.scss";
import { useNotificationContext } from "../../components/Notification";
import { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import XAccountBanner from "../../assets/images/x_account_banner.png";
import { httpsCallable } from "firebase/functions";

function Menu() {
  const { user, setUser, isSubscribed } = useAuthContext();
  const { setText } = useNotificationContext();
  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    const result = window.confirm("ログアウトしますか？");
    if (result) {
      signOut(auth)
        .then(() => {
          setText("ログアウトしました");
          setUser(auth.currentUser);
        })
        .catch((e) => {
          alert(e);
        });
    }
  };

  useEffect(() => {
    if (location.state && location.state.notificationText)
      setText(location.state.notificationText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickToCustomerPortal = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();

    if (isSubscribed) {
      try {
        const createCustomerPortalUrl = httpsCallable<
          unknown,
          { url: string | null }
        >(functions, "createCustomerPortalUrl");
        const { data } = await createCustomerPortalUrl({
          uid: user?.uid,
        });

        if (!data) {
          alert("エラーが発生しました。");
        }

        if (data?.url) {
          window.location.href = data.url;
        }
      } catch (error) {
        console.error("Error creating customer portal URL:", error);
        alert("エラーが発生しました。");
      }
    } else {
      navigate("/subscription");
    }
  };

  if (user) {
    return (
      <>
        <HeadBlock title={"メニュー"} path="menu" />
        <Header />
        <div className={styles.Menu}>
          <div className={styles.inner}>
            <h1>メニュー</h1>
            <NavLink
              className={styles.banner}
              to="https://twitter.com/Pazle_info"
              target="_blank"
            >
              <img src={XAccountBanner} alt="X (旧Twitter)公式アカウント" />
            </NavLink>
            <NavLink
              className={styles.banner}
              to="https://vectordesign.jp/pazle/top"
              target="_blank"
            >
              <img src={require("../../assets/images/banner.png")} alt="" />
            </NavLink>

            <button
              className={styles.subscriptionButton}
              type="button"
              onClick={onClickToCustomerPortal}
            >
              <i className={iconStyles.icon_subscription}></i>
              聴き放題プラン：{isSubscribed ? "加入済み" : "未加入"}
            </button>

            <ul>
              <li>
                <NavLink to="/menu/profile/edit">プロフィール</NavLink>
              </li>
            </ul>
            <ul>
              <li>
                <NavLink
                  to="https://docs.google.com/forms/d/e/1FAIpQLSdnS9xymPyO5EXHsHTIDrDwbTn3qMaRTw1W2vHft_nDE14KBA/viewform"
                  target="_blank"
                >
                  お問い合わせ
                </NavLink>
              </li>
              <li>
                <NavLink to="/menu/plans">
                  作品の購入・聴き放題プランについて
                </NavLink>
              </li>
              <li>
                <NavLink to="https://vectordesign.jp/" target="_brank">
                  運営会社について
                </NavLink>
              </li>
              <li>
                <NavLink to="/terms" target="_brank">
                  利用規約
                </NavLink>
              </li>
              <li>
                <NavLink to="/privacy" target="_brank">
                  プライバシーポリシー
                </NavLink>
              </li>
              <li>
                <NavLink to="/tokutei" target="_brank">
                  特定商取引法に基づく表記
                </NavLink>
              </li>
              <li>
                <NavLink to="/requirements" target="_brank">
                  動作環境について
                </NavLink>
              </li>
            </ul>
            <button type="button" className={styles.logout} onClick={logout}>
              ログアウト
            </button>
          </div>
        </div>
        <Nav />
      </>
    );
  } else {
    return (
      <>
        <HeadBlock title={"メニュー"} path="menu" />
        <Header />
        <div className={styles.Menu}>
          <div className={styles.inner}>
            <h1>メニュー</h1>
            <NavLink className={styles.btn_primary} to="/signin">
              ログイン / 登録
            </NavLink>
            <NavLink
              className={styles.banner}
              to="https://twitter.com/Pazle_info"
              target="_blank"
            >
              <img src={XAccountBanner} alt="X (旧Twitter)公式アカウント" />
            </NavLink>
            <NavLink
              className={styles.banner}
              to="https://vectordesign.jp/pazle/top"
              target="_blank"
            >
              <img src={require("../../assets/images/banner.png")} alt="" />
            </NavLink>
            <ul>
              <li>
                <NavLink
                  to="https://docs.google.com/forms/d/e/1FAIpQLSdnS9xymPyO5EXHsHTIDrDwbTn3qMaRTw1W2vHft_nDE14KBA/viewform"
                  target="_brank"
                >
                  お問い合わせ
                </NavLink>
              </li>
              <li>
                <NavLink to="/menu/plans">
                  作品の購入・聴き放題プランについて
                </NavLink>
              </li>
              <li>
                <NavLink to="https://vectordesign.jp/" target="_brank">
                  運営会社について
                </NavLink>
              </li>
              <li>
                <NavLink to="/terms" target="_brank">
                  利用規約
                </NavLink>
              </li>
              <li>
                <NavLink to="/privacy" target="_brank">
                  プライバシーポリシー
                </NavLink>
              </li>
              <li>
                <NavLink to="/tokutei" target="_brank">
                  特定商取引法に基づく表記
                </NavLink>
              </li>
              <li>
                <NavLink to="/requirements" target="_brank">
                  動作環境について
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <Nav />
      </>
    );
  }
}

export default Menu;
